var _path, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDownArrowFileSelection = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "9 7 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9408_254",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 10,
    width: 11,
    height: 7
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.30021 10.8964C8.10495 11.0917 8.10495 11.4083 8.30021 11.6036L12.5428 15.8462L12.8964 16.1997C13.0917 16.395 13.4082 16.395 13.6035 16.1997L13.9571 15.8462C13.9572 15.846 13.9574 15.8459 13.9576 15.8457L18.1997 11.6036C18.395 11.4083 18.395 11.0917 18.1997 10.8964L17.8462 10.5429C17.6509 10.3476 17.3343 10.3476 17.139 10.5429L13.25 14.432L9.36087 10.5429C9.16561 10.3476 8.84902 10.3476 8.65376 10.5429L8.30021 10.8964Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9408_254)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#14171A"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDownArrowFileSelection, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Down_Arrow_File_Selection.73abe7fa.svg";
export { ForwardRef as ReactComponent };